<template>
  <div class="getting-started-top">
    <div
      class="top-row d-flex justify-content-between align-items-start nowrap"
    >
      <!-- LEFT LAYOUT -->
      <div class="left-layout">
        <div v-if="type === 'back_to_school'" class="avatar avatar-square">
          <img class="avatar-text" v-lazy="localImg('Eniola.png')" alt="" />
        </div>

        <div v-else class="avatar avatar-square">
          <div class="avatar-text brand_inverse_bg brand_navy">G</div>
        </div>

        <!-- TITLE -->
        <div>
          <div
            v-if="type === 'back_to_school'"
            class="title font-weight-bold color_text"
          >
            Eniola from Gradely
          </div>

          <div v-else class="title font-weight-bold color_text">Gradely</div>

          <div class="meta color_grey_dark" v-if="type === 'getting started'">
            Getting started with Gradely
          </div>
          <div class="meta color_grey_dark" v-if="type === 'diagnostic'">
            What to do
          </div>
          <div class="meta color_grey_dark" v-if="type === 'catchup'">
            Improving with Gradely
          </div>
          <div class="meta color_grey_dark" v-if="type === 'tutor'">
            A+ Online Tutoring
          </div>

          <div class="meta color_grey_dark" v-if="type === 'back_to_school'">
            #Back2School with Gradely CatchUp!
          </div>
          <div class="meta color_grey_dark" v-if="type === 'recommendation'">
            Checkout our properly selected recommendations for you today
          </div>
          <div class="meta color_grey_dark" v-if="type === 'summer'">
            Exploring your curiosity
          </div>
        </div>
      </div>

      <!-- RIGHT LAYOUT -->
      <!-- <div class="avatar pointer">
        <span class="flex-center icon-ellipsis-h color_grey_dark font-18 pr-2"></span>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "GettingStartedTop",

  props: {
    type: {
      type: String,
      default: "getting started",
    },
  },

  computed: {
    ...mapGetters(["getSummerStatus"]),
  },
};
</script>

<style lang="scss">
.getting-started-top {
  .top-row {
    margin-bottom: 14px;
  }

  .left-layout {
    @include flex_row_start_nowrap;
    align-items: flex-start;

    .avatar {
      margin-right: 10px;

      @include breakpoint_max(xs) {
        @include equal_min_edge(34);
      }

      .avatar-text {
        font-size: 14px;
        line-height: 16px;
      }
    }

    .title {
      font-size: 14px;
      margin-bottom: 4px;
    }

    .meta {
      font-size: 12.5px;
      line-height: 18px;
    }
  }
}
</style>
